"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var styled_components_1 = __importDefault(require("styled-components"));

var prop_types_1 = __importDefault(require("prop-types"));

var Container = styled_components_1.default("div")(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n  width: ", ";\n  font-family: \"Nunito Sans\", sans-serif;\n"], ["\n  display: flex;\n  flex-direction: column;\n  width: ", ";\n  font-family: \"Nunito Sans\", sans-serif;\n"])), function (props) {
  return props.width;
});
var Label = styled_components_1.default("label")(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  font-weight: 700;\n  font-size: 14px;\n  margin-left: 12px;\n  margin-bottom: 11px;\n  color: ", ";\n"], ["\n  font-weight: 700;\n  font-size: 14px;\n  margin-left: 12px;\n  margin-bottom: 11px;\n  color: ", ";\n"])), function (props) {
  if (props.isMaterial) {
    if (props.hasError) {
      return "#E24C4C";
    } else if (props.hasWarning) {
      return "#F1A153";
    } else if (props.hasSuccess) {
      return "#4CE2A7";
    } else if (props.disabled) {
      return "#CCCCCC";
    }
  } else {
    return "#333333";
  }
});
var SInput = styled_components_1.default("input")(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  border: none;\n  background-color: ", ";\n  box-shadow: ", ";\n  border-radius: ", ";\n  padding: 12px;\n  font-family: \"Nunito Sans\", sans-serif;\n  font-size: 14px;\n  color: #333333;\n  transition: all 0.2s ease-in-out;\n  border-bottom: ", ";\n  &::placeholder {\n    color: #999999;\n  }\n  &:focus,\n  &:active {\n    outline: none;\n  }\n  &:focus {\n    box-shadow: ", ";\n    ", "\n  }\n  &:disabled {\n    box-shadow: none;\n    background-color: ", ";\n    border-bottom: ", ";\n  }\n"], ["\n  border: none;\n  background-color: ", ";\n  box-shadow: ", ";\n  border-radius: ", ";\n  padding: 12px;\n  font-family: \"Nunito Sans\", sans-serif;\n  font-size: 14px;\n  color: #333333;\n  transition: all 0.2s ease-in-out;\n  border-bottom: ", ";\n  &::placeholder {\n    color: #999999;\n  }\n  &:focus,\n  &:active {\n    outline: none;\n  }\n  &:focus {\n    box-shadow: ", ";\n    ", "\n  }\n  &:disabled {\n    box-shadow: none;\n    background-color: ", ";\n    border-bottom: ", ";\n  }\n"])), function (props) {
  return props.isMaterial ? "transparent" : "white";
}, function (props) {
  return props.isMaterial ? "none" : "0px 2px 4px 0px rgba(0, 0, 0, 0.1)";
}, function (props) {
  return props.isMaterial || props.leftParam ? "0px" : "3px";
}, function (props) {
  if (props.hasError || props.hasWarning || props.hasSuccess) {
    if (props.hasError) {
      return "2px solid #E24C4C";
    } else if (props.hasWarning) {
      return "2px solid #F1A153";
    } else if (props.hasSuccess) {
      return "2px solid #4CE2A7";
    }
  } else {
    if (props.isMaterial) {
      return "2px solid #666666";
    }
  }
}, function (props) {
  return props.isMaterial ? "none" : "0px 5px 8px 0px rgba(0, 0, 0, 0.1)";
}, function (props) {
  if (props.isMaterial) {
    return "border-bottom: 2px solid #2D4EF5";
  }
}, function (props) {
  if (!props.isMaterial) {
    return "#ebebeb";
  }
}, function (props) {
  return props.isMaterial ? "2px solid #EBEBEB" : "none";
});
var Message = styled_components_1.default("span")(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  margin-top: 10px;\n  font-size: 14px;\n  margin-left: ", ";\n  color: ", ";\n"], ["\n  margin-top: 10px;\n  font-size: 14px;\n  margin-left: ", ";\n  color: ", ";\n"])), function (props) {
  return props.isMaterial ? "12px" : "0px";
}, function (props) {
  if (props.hasError) {
    return "#E24C4C";
  } else if (props.hasSuccess) {
    return "#4CE2A7";
  } else if (props.hasWarning) {
    return "#F1A153";
  }
});

exports.Input = function (_a) {
  var value = _a.value,
      label = _a.label,
      placeholder = _a.placeholder,
      _b = _a.multiline,
      multiline = _b === void 0 ? false : _b,
      _c = _a.isMaterial,
      isMaterial = _c === void 0 ? false : _c,
      name = _a.name,
      id = _a.id,
      _d = _a.width,
      width = _d === void 0 ? "500px" : _d,
      _e = _a.hasError,
      hasError = _e === void 0 ? false : _e,
      _f = _a.hasWarning,
      hasWarning = _f === void 0 ? false : _f,
      _g = _a.hasSuccess,
      hasSuccess = _g === void 0 ? false : _g,
      errorMsg = _a.errorMsg,
      warningMsg = _a.warningMsg,
      successMsg = _a.successMsg,
      _h = _a.disabled,
      disabled = _h === void 0 ? false : _h,
      className = _a.className;
  return react_1.default.createElement(Container, {
    className: className,
    width: width
  }, label ? react_1.default.createElement(Label, {
    htmlFor: id,
    isMaterial: isMaterial,
    hasError: hasError,
    hasWarning: hasWarning,
    hasSuccess: hasSuccess,
    disabled: disabled
  }, label) : null, react_1.default.createElement(SInput, {
    id: id,
    name: name,
    value: value,
    placeholder: placeholder,
    as: multiline ? "textarea" : "input",
    isMaterial: isMaterial,
    hasError: hasError,
    hasWarning: hasWarning,
    hasSuccess: hasSuccess,
    disabled: disabled
  }), hasError && react_1.default.createElement(Message, {
    hasError: true,
    isMaterial: isMaterial
  }, errorMsg), hasWarning && react_1.default.createElement(Message, {
    hasWarning: true,
    isMaterial: isMaterial
  }, warningMsg), hasSuccess && react_1.default.createElement(Message, {
    hasSuccess: true,
    isMaterial: isMaterial
  }, successMsg));
};

exports.Input.propTypes = {
  value: prop_types_1.default.string.isRequired,
  label: prop_types_1.default.string,
  placeholder: prop_types_1.default.string,
  multiline: prop_types_1.default.bool,
  isMaterial: prop_types_1.default.bool,
  name: prop_types_1.default.string.isRequired,
  id: prop_types_1.default.string.isRequired,
  width: prop_types_1.default.string,
  hasError: prop_types_1.default.bool,
  hasWarning: prop_types_1.default.bool,
  hasSuccess: prop_types_1.default.bool,
  errorMsg: prop_types_1.default.string,
  warningMsg: prop_types_1.default.string,
  successMsg: prop_types_1.default.string,
  disabled: prop_types_1.default.bool,
  className: prop_types_1.default.string
};
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;